// Route prefixes used to detect which sub-app a path belongs to. Shared between
// render-app (post-load routing) and authenticated-app (pre-load loading shell)
// so both stay in lockstep — drift here causes the wrong app's chrome to flash
// during the loading window.

export const ACCESS_MANAGEMENT_ROUTES = [
  '/duties',
  '/conflicts',
  '/users',
  '/roles',
  '/permissions',
  '/business-rules',
  '/processes',
  '/issues',
  '/audit-logs',
  '/access-management-exports',
  '/sod-exports',
  '/data-access'
]

export const USER_ROUTES = [
  '/dashboards',
  '/account-groups',
  '/vendors',
  '/transactions',
  '/employees',
  '/samples',
  '/analytics',
  '/saved',
  '/exports',
  '/reports',
  '/admin'
]

// NOTE: '/settings' is intentionally NOT listed under any app. It's a
// cross-app page (reachable from analytics, SOD, and datum), so render-app
// keeps the user in their current app (currentApp) rather than pinning
// Settings to one app's chrome. Adding it to a list would teleport a
// multi-app user into that app's sidebar when they click Settings.

export const DATUM_ROUTES = ['/datum']

export const pathMatches = (path, prefixes) =>
  prefixes.some((prefix) => path.startsWith(prefix))
